module.exports = __webpack_public_path__ + "media/images/front/materials/tierra-bf20b5364b2a485a5e408a09fb4d2646.jpg";